export default "__VITE_ASSET__8ebf662d__"